import React from "react";
import styles from "./TopicSettingsItem.module.scss";
import menuStyles from "./SettingsItemMenu.module.scss";
import { genStatusText, getDefaultImage } from "../../../utils/GeneralUtils";
import { PageVisibility } from "../../../utils/PageVisibility";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SonicLink from "../../routing/SonicLink";

type Props = {
  id?: string;
  name?: string;
  status?: string;
  handleMenu: () => void;
  handlePublish: (id?: string) => void;
  handlePrivate: (id?: string) => void;
  edit_link: string;
  detail_link: string;
  isMenuOpen: boolean;
  isOwner: boolean;
  start_date?: number;
  img_src?: string;
};
const TopicSettingsItem: React.FC<Props> = ({
  id,
  name,
  status,
  handleMenu,
  handlePublish,
  handlePrivate,
  edit_link,
  detail_link,
  isMenuOpen,
  isOwner,
  start_date,
  img_src,
}) => {
  const status_class =
    status === PageVisibility.AwaitingInspection
      ? styles["pending"]
      : status === PageVisibility.PubliclyVisible
      ? styles["open"]
      : "";

  return (
    <div className={styles["topicSettingsItem"]}>
      <div className={styles["topicSettingsItem__top"]}>
        <div className={styles["topicSettingsItem__top__imgBox"]}>
          <img src={img_src ? img_src : getDefaultImage()} />
        </div>
        <div
          className={`${styles["topicSettingsItem__top__status"]} ${status_class}`}
        >
          {genStatusText(status, start_date)}
        </div>
      </div>
      <div className={styles["topicSettingsItem__bottom"]}>{name}</div>
      <button
        className={styles["topicSettingsItem__menuBtn"]}
        onClick={handleMenu}
      >
        <FontAwesomeIcon icon={["fal", "ellipsis-h"]} />
      </button>
      <div
        className={
          isMenuOpen
            ? `${menuStyles["f-settingItemMenu"]} ${menuStyles["open"]}`
            : menuStyles["f-settingItemMenu"]
        }
        onClick={handleMenu}
      >
        <div className={menuStyles["f-settingItemMenu__inner"]}>
          <div className={menuStyles["f-settingItemMenu__top"]}>
            <div>{name}</div>
            <FontAwesomeIcon
              icon={["fal", "times-circle"]}
              onClick={handleMenu}
            />
          </div>
          <ul className={menuStyles["f-settingItemMenu__list"]}>
            {isOwner !== false && edit_link ? (
              <li>
                <SonicLink
                  to={edit_link}
                  className={menuStyles["f-settingItemMenu__list__link"]}
                >
                  <FontAwesomeIcon icon={["fal", "edit"]} />
                  トピックス編集
                </SonicLink>
              </li>
            ) : null}
            {status === PageVisibility.PubliclyVisible ? (
              <li>
                <SonicLink
                  to={detail_link}
                  className={menuStyles["f-settingItemMenu__list__link"]}
                >
                  <FontAwesomeIcon icon={["fal", "info-circle"]} />
                  トピックス詳細
                </SonicLink>
              </li>
            ) : null}
            {isOwner !== false &&
            status == PageVisibility.NotPubliclyVisible &&
            handlePublish ? (
              <li
                onClick={() => handlePublish(id)}
                className={menuStyles["f-settingItemMenu__list__private"]}
              >
                <FontAwesomeIcon icon={["fal", "lock-alt"]} />
                トピックス公開申請
              </li>
            ) : null}
            {isOwner !== false &&
            status !== PageVisibility.NotPubliclyVisible &&
            handlePrivate ? (
              <li
                onClick={() => handlePrivate(id)}
                className={menuStyles["f-settingItemMenu__list__private"]}
              >
                <FontAwesomeIcon icon={["fal", "lock-alt"]} />
                トピックス非公開
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TopicSettingsItem;
